import React, { useMemo } from "react";

export interface IInputProps {
  name: string;
  label?: string;
  type?: string;
  onChange?: any;
  values?: any;
  errors?: any;
  touches?: any;
  onBlur?: any;
  disabled?: boolean;
  autoFocus?: any;
  className?: any;
  placeholder?: any;
  onKeyDown?: any;
  defaultValue?: any;
  hidden?: any;
  min?: any;
  pattern?: any;
}

export default function Input(props: IInputProps) {
  const isInvalid = useMemo(() => {
    return props?.touches[props?.name] && props?.errors[props?.name];
  }, [props?.touches, props?.errors, props?.name]);

  return (
    <div className="flex flex-col justify-start items-start gap-1">
      <label
        htmlFor={props.name}
        className={`text-[14px]  text-[#1A1A1A] ${props?.hidden && "hidden"}`}
      >
        {props.label}
      </label>

      <input
        disabled={props.disabled}
        className={
          props?.className
            ? props?.className
            : "flex items-center w-full focus:outline-none px-2 h-6 py-4 border  text-[16px] border-[#E6E6E6] leading-5.2 rounded-md "
        }
        id={props?.name}
        placeholder={props.placeholder}
        name={props?.name}
        onChange={props?.onChange}
        autoFocus={props?.autoFocus}
        onBlur={props?.onBlur}
        type={props?.type}
        value={props?.values[props?.name]}
        onKeyDown={props?.onKeyDown}
        defaultValue={props?.defaultValue}
        min={props?.min}
        pattern={props?.pattern}
      />

      {isInvalid ? (
        <p className="text-red-500 font-[600] text-[10px]">
          {props?.errors[props?.name]}
        </p>
      ) : null}
    </div>
  );
}
